<div fxLayout.gt-xs="row" fxLayout="column" fxLayoutGap="10px">
  <mat-form-field [formGroup]="formGroup" appearance="outline" fxFlex>
    <mat-label>Cidade</mat-label>
    <input #cdCidade type="text" id="cdCidade" matInput placeholder="Cidade" formControlName="cidade"
      (input)="cdCidade.value=$event.target.value.toUpperCase()" [matAutocomplete]="auto" autocomplete="new-password" />
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" panelWidth="auto"
      (optionSelected)="cidadeSelecionada($event)">
      <mat-option *ngFor="let cidade of cidadesFiltradas" [value]="cidade">
        {{cidade.dsCidade}}
      </mat-option>
    </mat-autocomplete>
    <mat-icon matPrefix>search</mat-icon>
  </mat-form-field>
  <mat-form-field appearance="outline" fxFlex fxFlex.gt-xs="20">
    <input #sgEstado type="text" id="sgEstado" matInput placeholder="UF" readonly />
  </mat-form-field>
</div>